const e = "Opłata za dostawę", o = "Inne opłaty", a = "Zwrot pieniędzy", n = "Metody płatności", i = "Płacić", t = "Szczebel", r = "Zwrotnica", s = "Karta lojalnościowa", d = "Nagrody", c = "Rabat", p = "Wskazówka", l = "Całkowity", u = "Suma częściowa", z = "Dostarczony", m = "Przygotowywać", w = "Dostarczać", y = "En sala", h = "Na wynos", g = "Załaduj więcej", k = "Ratować", j = "Nazwa", b = "Nazwisko", L = "E-mail", f = "Urodziny", P = "Tagi", v = "Płeć", T = "Język", A = "Kod pocztowy", V = "aaa", W = "Dostawa", S = "Ulec poprawie", x = "Nieznany", Z = "Telefon", O = "Dzisiaj", C = "Jutro", N = "Dzień", K = "Czas", I = "Dzwonić", B = "Gość", U = "Zaloguj się lub zarejestruj", D = "Ubera", G = "Glovo", R = "Dostarcz", M = "Justeat", E = {
  "stampCard.complete": "Gratulacje! Ukończyłeś wszystkie dostępne cykle.",
  "stampCard.cycleEnd": "Zdobyłeś nową nagrodę. Dziękujemy za odwiedziny!",
  "stampCard.expired": "Karta wygasła",
  "stampCard.expirationLabel": "Ważność:",
  "userOrders.empty": "Twoja historia zamówień jest pusta",
  "userOrders.info": "Wybierz zamówienie, aby wyświetlić szczegóły potwierdzenia",
  deliveryFee: e,
  defaultFeeName: o,
  "shopLanding.tableInput.error": "Stół, którego szukasz nie istnieje, sprawdź numer swojego stołu lub zapytaj kelnera",
  "shopLanding.restaurants.title.takeaway": "Gdzie odbierzesz swoje zamówienie?",
  "shopLanding.tableInput.title": "Jaki jest twój stół?",
  "shopLanding.restaurants.noResults": "Brak wyników",
  "shopLanding.restaurants.title.dineIn": "Gdzie się znajdujesz?",
  continue: "Kontynuować",
  "kioskLanding.outOfOrder.title": "Brak porządku",
  "kioskLanding.outOfOrder.subtitle": "Zamówienia nie są obecnie przyjmowane. Aby złożyć zamówienie, skonsultuj się z kelnerem.",
  "kioskLanding.language.title": "Wybierz język",
  "kioskLanding.service.title": "Gdzie chcesz mieć swoje zamówienie?",
  "kioskLanding.service.takeaway": "Zabierać",
  "kioskLanding.service.dineIn": "Zjedz obiad",
  "kioskLanding.service.otherLanguages": "Inne języki",
  "kioskLanding.inactive.title": "Czy chcesz kontynuować zamówienie?",
  "kioskLanding.inactive.prelude": "Zostanie automatycznie anulowane",
  "kioskLanding.inactive.cancel": "Anuluj zamówienie",
  "kioskLanding.inactive.continue": "Kontynuować",
  "userGreetings.defaultUnAuthenticatedText": "Zaloguj się",
  "userGreetings.defaultAuthenticatedText": "Witamy, *|customer_name|*",
  "viewOrder.cashbackSpent": "Wydano {{denomination}}",
  "viewOrder.cashbackObtained": "Uzyskano {{denomination}}",
  "orderRecord.anonOrderText": "Aktualizacja ręczna",
  "myCashback.historyTitle": "Historia {{denomination}}",
  "myCashback.denomination": "Aktualny {{denomination}}",
  cashback: a,
  "loginPage.prelude": "Aby wyświetlić tę stronę, musisz się zalogować",
  "loginPage.callToAction": "Kliknij tutaj, aby się zalogować",
  paymentMethods: n,
  "shopLanding.singleRestaurant.delivery.title": "Kiedy chcesz swoje zamówienie?",
  "shopLanding.fetchAction.confirmation.accept": "Przyjąć",
  "shopLanding.fetchAction.confirmation.cancel": "Anulować",
  "shopLanding.fetchAction.confirmation.title": "Czy jesteś pewien?",
  "shopLanding.fetchAction.confirmation.body": "Proszę potwierdzić tę czynność",
  "shopLanding.fetchAction.2xx.title": "Sukces",
  "shopLanding.fetchAction.2xx": "{status} Sukces",
  "shopLanding.fetchAction.3xx.title": "Przeadresować",
  "shopLanding.fetchAction.3xx": "{status} Przekierowanie",
  "shopLanding.fetchAction.error.title": "Błąd",
  "shopLanding.fetchAction.error": "{status} Błąd",
  "shopLanding.loadingRestaurants": "Przygotowanie restauracji",
  "shopLanding.book.confirmation.bookingPolicy.label": "Wyrażam zgodę na przetwarzanie danych osobowych",
  "shopLanding.book.error.text": "Coś poszło nie tak. Spróbuj ponownie później.",
  "shopLanding.book.success.title": "Twoja rezerwacja została zakończona",
  "shopLanding.book.success.text": "Twoja rezerwacja została zakończona",
  "shopLanding.book.confirmation.submit": "Potwierdzać",
  "shopLanding.book.confirmation.marketing.label": "Wyrażam zgodę na otrzymywanie promocji marki na mój adres e-mail",
  "shopLanding.book.confirmation.form.observations.placeholder": "Obserwacje",
  "shopLanding.book.confirmation.form.observations.label": "Obserwacje",
  "shopLanding.book.confirmation.form.area.placeholder": "Pokój 1",
  "shopLanding.book.confirmation.form.area.label": "Wybierz obszar",
  "shopLanding.book.confirmation.title": "Potwierdź rezerwację:",
  "shopLanding.book.listing.submit": "Kontynuować",
  "shopLanding.book.listing.title": "Zarezerwuj pod adresem:",
  "shopLanding.book.notMatch.text": "W tej chwili nie możemy zaoferować Ci lokalizacji odpowiadających Twoim preferencjom.",
  "shopLanding.book.notMatch.title": "Brak pasujących lokalizacji",
  "shopLanding.book.reservation.submit": "Znajdź restaurację",
  "shopLanding.book.reservation.title": "Dokonaj rezerwacji",
  "shopLanding.book.nOfPeople": "Liczba osób",
  "shopLanding.book": "Książka",
  "magiclink.tryAgain": "Spróbować ponownie",
  "magiclink.email.code.input": "Wpisz kod",
  "magiclink.email.code.try.again": "Zacznij od nowa",
  "magiclink.email.code.continue": "Kontynuować",
  "magiclink.email.title": "Wpisz kod, który wysłaliśmy na Twój e-mail",
  "magiclink.email.code.error": "Nieprawidłowy kod",
  "magiclink.email.content": "Wkrótce otrzymasz link dostępowy na swój adres e-mail. Jeśli nie możesz znaleźć go w swojej skrzynce odbiorczej, sprawdź folder ze spamem.",
  "payments.engine.7": "Zapłać później",
  "payments.engine.10": "Karta, Apple pay lub Google Pay",
  "payments.redirect.verifying": "Przetwarzanie płatności…",
  "payments.redirect.errorTitle": "Nie udało się zrealizować płatności.",
  "payments.redirect.error": "Wystąpił błąd lub płatność została anulowana. Spróbuj ponownie.",
  "payments.method.5": "Gotówka",
  "payments.method.4": "Bizum",
  "payments.method.3": "Płaci Apple",
  "payments.method.2": "Google płaci",
  "payments.method.1": "Karta kredytowa",
  "shopLanding.legal.bookingPolicy": "Polityka rezerwacji",
  "shopLanding.legal.cookiesPolicy": "Polityka plików cookies",
  "shopLanding.legal.privacyPolicy": "Polityka prywatności",
  "shopLanding.legal.termsAndConditions": "Warunki zakupu",
  payLink: i,
  "loyaltyCard.disabled": "Karta stałego klienta jest obecnie niedostępna",
  tier: t,
  points: r,
  loyaltyCard: s,
  vouchers: d,
  "weekdays.short.monday": "pon",
  "weekdays.short.tuesday": "wt",
  "weekdays.short.wednesday": "Poślubić",
  "weekdays.short.thursday": "czwartek",
  "weekdays.short.friday": "piątek",
  "weekdays.short.saturday": "sob",
  "weekdays.short.sunday": "Słoneczny",
  "voucher.expiredBurnBtnText": "Oferta niedostępna",
  "voucher.burnBtnText": "Oznacz kupon jako wykorzystany",
  "voucher.terms.scheduleAllDays": "Wszystkie dni",
  "voucher.terms.schedule": "Harmonogram",
  "voucher.terms.usesTimeframe.43200": "używa co 12 godzin",
  "voucher.terms.usesTimeframe.86400": "codziennego użytku",
  "voucher.terms.usesTimeframe.604800": "cotygodniowe zastosowania",
  "voucher.terms.usesTimeframe.2592000": "miesięcznych zastosowań",
  "voucher.terms.maximum": "Maksymalny:",
  "voucher.terms.usesTotal": "Całkowita liczba zastosowań",
  "voucher.terms.usesAndLimitations": "Zastosowania i ograniczenia",
  "terms.title": "Regulamin",
  "voucher.error.noMoreUses": "Nie ma już żadnych zastosowań",
  "voucher.error.outOfSchedule": "Poza harmonogramem",
  "voucher.error.nextActivation": "Następna aktywacja",
  "addToWallet.android": "Portfel Google",
  "addToWallet.apple": "Dodaj do portfela Apple",
  "voucher.unlimited": "Nieograniczony",
  "voucher.validFromTitle": "Obowiązuje od",
  "voucher.validUntilTitle": "Ważne do",
  "voucher.remainingUsesTitle": "Pozostałe zastosowania",
  "voucher.pendingValidation": "Konto oczekuje na weryfikację",
  "voucher.verify": "Zweryfikuj",
  "ticket.placed": "Umieszczony",
  "ticket.followOrderBtn": "Postępuj zgodnie ze swoim zamówieniem",
  discount: c,
  tip: p,
  total: l,
  subtotal: u,
  "order.status.unconfirmed": "Niepotwierdzone",
  "order.status.confirmed": "Potwierdzony",
  "order.status.ready": "Gotowy",
  "order.status.onroute": "Na trasie",
  "order.status.completed": "Zakończony",
  "order.status.cancelled": "Odwołany",
  order_delivered: z,
  order_preparation: m,
  order_deliver: w,
  dinein: y,
  takeaway: h,
  loadMore: g,
  "userOrders.heading": "Historia zamówień",
  "userProfile.emptyTagsText": "Nie masz jeszcze żadnych tagów! Kliknij tutaj, aby dodać jeden",
  "gender.male": "Mężczyzna",
  "gender.female": "Kobieta",
  "gender.other": "Inny",
  "gender.na": "Nie dotyczy",
  "userProfile.editInfoHeading": "Edytuj swoje dane",
  save: k,
  name: j,
  surname: b,
  email: L,
  birthday: f,
  tags: P,
  gender: v,
  language: T,
  postCode: A,
  "userProfile.navigation.profile": "Profil",
  "navigation.back": "Z powrotem",
  "shopLanding.address.error.unknown": "Coś poszło nie tak. Spróbuj ponownie później",
  "shopLanding.address.error.locationTemporarilyUnavailable": "Przepraszamy, ta usługa jest obecnie niedostępna",
  "shopLanding.address.error.addressBothEmpty": "Proszę wypełnić pola adresu i piętra/drzwi",
  "shopLanding.address.error.addressEmpty": "Proszę wypełnić pole adresowe",
  "shopLanding.address.error.addressInfoEmpty": "Proszę wypełnić pole piętro/drzwi",
  "shopLanding.singleRestaurant.eta.time": "{{time}} min",
  "shopLanding.singleRestaurant.eta": "Szacowany czas przygotowania:",
  "shopLanding.redirection.title": "Gratulacje!",
  "shopLanding.redirection": "Przekierowujemy Cię, abyś mógł złożyć zamówienie",
  "shopLanding.noReach.title": "Nie obsługujemy Twojego obszaru",
  testDoNotTouch: "aaa",
  "userMenu.showProfile": "Pokaż profil",
  "userMenu.logout": "Wyloguj się",
  "autocomplete.label": "Adres",
  "autocomplete.placeholder": "Wprowadź adres wraz z numerem",
  "autocomplete.geolocation": "Użyj mojej aktualnej lokalizacji",
  "shopLanding.address.title": "Skąd zamawiasz?",
  "shopLanding.address.label": "Podłoga, drzwi...",
  "shopLanding.address.placeholder": "Podaj adres dostawy lub wpisz spację, jeśli nie dotyczy",
  "shopLanding.address.error.suspended": "Przepraszamy, w tej chwili nie możemy przyjąć więcej zamówień. Spróbuj ponownie za 20 minut lub złóż zamówienie w przedsprzedaży na później.",
  "shopLanding.address.error.outOfRange": "Ups... w tej chwili nie docieramy do Twojego obszaru. Spróbuj zamówić na wynos z najbliższej lokalizacji.",
  "shopLanding.address.error.cannotDeliver": "Przepraszamy, obecnie nie jesteśmy w stanie dostarczyć zamówienia pod Twój adres. Spróbuj zamówić na wynos z najbliższej lokalizacji.",
  "shopLanding.address.error.invalidAddress": "Przepraszamy, adres jest nieprawidłowy. Sprawdź to i wprowadź ponownie.",
  "shopLanding.address.error.missingStreet": "Proszę podać numer ulicy",
  "shopLanding.address.error.orderThrough": "Możesz też zamówić poprzez:",
  "shopLanding.selector.title": "Odbierz swoje zamówienie pod adresem: ",
  "shopLanding.selector.laterBtn": "Zamów w przedsprzedaży",
  "shopLanding.selector.nowBtn": "Zamów teraz",
  "shopLanding.selector.doOrder": "Zamówienie",
  "shopLanding.datetime.title": "Wybierz czas:",
  "shopLanding.datetime.dayPlaceholder": "Wybierz dzień..",
  "shopLanding.datetime.hourPlaceholder": "Wybierz godzinę..",
  "shopLanding.datetime.cancelBtn": "Anulować",
  "shopLanding.datetime.programBtn": "Zamów w przedsprzedaży",
  "shopLanding.singleRestaurant.title": "Ta lokalizacja dostarczy Twoje zamówienie:",
  delivery: W,
  pickup: S,
  unknown: x,
  phone: Z,
  today: O,
  tomorrow: C,
  day: N,
  hour: K,
  call: I,
  guest: B,
  loginText: U,
  uber: D,
  glovo: G,
  deliveroo: R,
  justeat: M,
  "phoneVerification.title": "Zweryfikuj swój numer telefonu",
  "phoneVerification.subtitle": "Otrzymasz kod SMS na numer {{phoneNumber}}",
  "phoneVerification.countdown": "Jeśli nie dotrze, możesz poprosić o kolejny kod za {{time}}",
  "phoneVerification.resend": "Poproś o kolejny kod",
  "phoneVerification.back": "Wstecz",
  "phoneVerification.continue": "Kontynuuj",
  "phoneVerification.error": "Nieprawidłowy kod",
  "phoneVerification.error.invalidCode": "Wprowadzony kod jest nieprawidłowy. Spróbuj ponownie.",
  "phoneVerification.error.expired": "Kod wygasł. Proszę poprosić o nowy.",
  "phoneVerification.error.alreadyUsed": "Ten kod został już użyty. Proszę poprosić o nowy.",
  "phoneVerification.error.attemptsExceeded": "Zbyt wiele nieprawidłowych prób. Proszę poprosić o nowy kod.",
  "phoneVerification.error.generic": "Coś poszło nie tak. Spróbuj ponownie.",
  "phoneInputForm.error.otpRequestCooldown": "Proszę poczekać przed wysłaniem nowego kodu.",
  "phoneInputForm.error.otpRateLimit": "Zbyt wiele żądań. Spróbuj ponownie później.",
  "phoneInputForm.error.smsProviderError": "Nie udało się wysłać SMS-a. Spróbuj ponownie.",
  "phoneInputForm.title": "Wprowadź swój numer telefonu",
  "phoneInputForm.phoneLabel": "Telefon",
  "phoneInputForm.back": "Wstecz",
  "phoneInputForm.continue": "Kontynuuj",
  "duplicatePhoneError.title": "Użytkownik z tym numerem już istnieje",
  "duplicatePhoneError.subtitle": "Numer telefonu Twojego konta jest już zarejestrowany przez innego użytkownika na platformie. Zaloguj się za pomocą powiązanego adresu e-mail.",
  "duplicatePhoneError.back": "Wróć"
};
export {
  f as birthday,
  I as call,
  a as cashback,
  N as day,
  E as default,
  o as defaultFeeName,
  R as deliveroo,
  W as delivery,
  e as deliveryFee,
  y as dinein,
  c as discount,
  L as email,
  v as gender,
  G as glovo,
  B as guest,
  K as hour,
  M as justeat,
  T as language,
  g as loadMore,
  U as loginText,
  s as loyaltyCard,
  j as name,
  w as order_deliver,
  z as order_delivered,
  m as order_preparation,
  i as payLink,
  n as paymentMethods,
  Z as phone,
  S as pickup,
  r as points,
  A as postCode,
  k as save,
  u as subtotal,
  b as surname,
  P as tags,
  h as takeaway,
  V as testDoNotTouch,
  t as tier,
  p as tip,
  O as today,
  C as tomorrow,
  l as total,
  D as uber,
  x as unknown,
  d as vouchers
};
//# sourceMappingURL=translation.json.js.map
